import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon, MapPinIcon } from "lucide-react";
const HERO_IMAGE = "https://cdn.magicpatterns.com/patterns/generated-images/15949ac6-4cf3-48cf-b546-cce34e4f99f5.jpg";
export function Hero() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-ink" data-id="element-90" data-mp="4mrt0xbedtjn">
      <img src={HERO_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-91" data-mp="1297cg4ndx19u" />
      <div className="absolute inset-0 bg-ink/65" aria-hidden="true" data-id="element-92" data-mp="xae6qyecaek8" />

      <div className="relative mx-auto flex min-h-[640px] max-w-7xl flex-col justify-end px-6 pb-16 pt-32 lg:min-h-[720px] lg:px-10 lg:pb-20" data-id="element-93" data-mp="xb5w3rhcfg22">
        <motion.div initial={reduce ? false : {
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-94" data-mp="ncq2nhuufupe">
          <p className="flex items-center gap-2 text-sm text-white/80" data-id="element-95" data-mp="381nvnbrr4x50">
            <MapPinIcon className="h-4 w-4" data-id="element-96" data-mp="3j7zcjaz8recz" />
            Cabinet de gestion de patrimoine à Paris
          </p>
          <h1 className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-white sm:text-5xl lg:text-7xl" data-id="element-97" data-mp="3o6kfvj9sie5n">
            Des solutions financières et fiscales adaptées à votre situation
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-98" data-mp="3e8ecsyc8z1z7">
            Investissement, épargne, fiscalité, retraite, transmission : un accompagnement sur mesure, de la
            stratégie au suivi.
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-99" data-mp="35aucbrm7l9pn">
            <a href="#contact" className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-brand-light" data-id="element-100" data-mp="2ql6b0qe12b1x">
              Prendre rendez-vous
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-101" data-mp="2ljpbay7a4umx" />
            </a>
            <a href="#besoins" className="inline-flex items-center justify-center rounded-full border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-white/10" data-id="element-102" data-mp="s3ckw8bgjfpi">
              Découvrir nos solutions
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}